<div class="toaster">
  @for (message of messages(); track message.id) {
    <div
      class="toast"
      [class.toast--success]="message.type === 'success'"
      [class.toast--info]="message.type === 'info'"
      [attr.role]="message.type === 'error' ? 'alert' : 'status'"
      [attr.aria-live]="message.type === 'error' ? 'assertive' : 'polite'">
      <span class="toast__text">{{ message.text }}</span>
      <button type="button" class="toast__close" aria-label="Dismiss" (click)="dismiss(message.id)">×</button>
    </div>
  }
</div>
